var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    ref: "item",
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_vm.message.type == 'noti' ? [_c('item-noti', _vm._b({}, 'item-noti', {
    message: _vm.message
  }, false))] : _vm._e(), _vm.message.type == 'peer' ? [_c('item-peer', _vm._b({}, 'item-peer', {
    message: _vm.message,
    index: _vm.index
  }, false))] : _vm._e(), _vm.message.type == 'user' ? [_c('item-user', _vm._b({}, 'item-user', {
    message: _vm.message,
    index: _vm.index
  }, false))] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }